import Router from 'next/router'
import { post } from '@api/apiFetcher'
import mutateUser from '@utils/user/mutateUser'
import MessageHelper from '@utils/messageHelper'

const useFormGenericPostHandler =
    (path, user, callback) =>
        (data) => {
            post({ path, data, auth: user?.token })
                .then(res => {
                    MessageHelper.summary(res)
                    if (res.success) {
                        if (res.user) {
                            mutateUser(user, res.user)
                        }

                        if (res.redirect) {
                            Router.push(res.redirect)
                        }

                        if (callback) {
                            callback(res)
                        }
                    }
                })
        }

export default useFormGenericPostHandler